import { render, staticRenderFns } from "./listHistoryApproval.vue?vue&type=template&id=81403030&scoped=true&"
import script from "./listHistoryApproval.vue?vue&type=script&lang=js&"
export * from "./listHistoryApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81403030",
  null
  
)

export default component.exports